// extracted by mini-css-extract-plugin
export default {"form":"CheckOut_form__QUHg1","control":"CheckOut_control__yvpI+","actions":"CheckOut_actions__OmIMk","submit":"CheckOut_submit__nP3k6","invalid":"CheckOut_invalid__nGylO"};